import { render, staticRenderFns } from "./sliceAddressManagement.vue?vue&type=template&id=ff4ad52a&scoped=true&"
import script from "./sliceAddressManagement.vue?vue&type=script&lang=js&"
export * from "./sliceAddressManagement.vue?vue&type=script&lang=js&"
import style0 from "./sliceAddressManagement.vue?vue&type=style&index=0&id=ff4ad52a&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff4ad52a",
  null
  
)

export default component.exports